import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { FilterSubPanel } from "./FilterSubPanel";
import { CloseButton } from "./CloseButton";

export class FilterSelect extends Component {
    isNotReversed = (high, low) =>
        this.props.options[high][low].transactions !== this.props.options[high][low].reversals * 2;

    getPanels = () => {
        const largestLowGroup = Math.max.apply(
            Math,
            this.props.ordinals.map(f => f.lows.length)
        );
        const panels = [
            <FilterSubPanel
                key={0}
                title={"All transactions"}
                lows={["All transactions"]}
                options={this.props.options}
                parentFilterSelect={this.props.filterSelect}
            />
        ];
        this.props.ordinals
            .filter(ord => ord.high !== "N/A")
            .filter(ord => ord.lows.find(low => this.isNotReversed(ord.high, low)))
            .forEach(ord => {
                panels.push(
                    <FilterSubPanel
                        key={panels.length}
                        title={ord.high}
                        lows={ord.lows.filter(low => this.isNotReversed(ord.high, low))}
                        options={this.props.options}
                        rowNumTarget={largestLowGroup}
                        parentFilterSelect={this.props.filterSelect}
                        firstPanel={panels.length === 1}
                    />
                );
            });

        return panels;
    };

    render() {
        return (
            <div>
                <ShowHideDiv shown={this.props.shown}>
                    <FloatRight>
                        <CloseButton action={this.props.hidePanel} />
                    </FloatRight>
                    {this.getPanels()}
                </ShowHideDiv>
            </div>
        );
    }
}

const ShowHideDiv = styled.div`
    background-color: ${props => props.theme.tertiary};
    border-color: ${props => props.theme.primary};
    position: absolute;
    border-style: solid;
    border-width: 1px;
    padding: 10px;
    z-index: 999;
    margin-top: 2px;
    margin-right: 10px;
    min-width: 245px;
    max-width: 915px;
    box-shadow: 3px 3px 20px #888;

    ${props => !props.shown && "display: none;"}
`;

const FloatRight = styled.div`
    float: right;
`;

FilterSelect.propTypes = {
    options: PropTypes.object,
    filterSelect: PropTypes.func,
    ordinals: PropTypes.array,
    shown: PropTypes.bool,
    hidePanel: PropTypes.func
};
